import * as React from "react";
import { UitkCardAlohaPlaceholder } from "uitk-react-cards";
import { IsomorphicCarousel } from "components/shared/IsomorphicCarousel/IsomorphicCarousel";
import { useLocalization } from "@shared-ui/localization-context";
import { ItemKeyHelper } from "components/utility/ItemKeyHelper";
import { DealsPlaceholderProps } from "./typings";
import { UitkSpacing } from "uitk-react-spacing";

// placeholder for the campaign deals that will be displayed until the data is fetched
export const DealsPlaceholder = (dealsPlaceholderProps: DealsPlaceholderProps) => {
  const { formatText } = useLocalization();
  const keyHelper = new ItemKeyHelper(`${dealsPlaceholderProps.flexTemplateNodeId}-placeholder-Carousel`);

  return (
    <UitkSpacing margin={{ blockend: "three", blockstart: "four" }}>
      <div data-testid="deals-placeholder" className="Deals" id={dealsPlaceholderProps.flexTemplateNodeId}>
        <UitkSpacing margin={{ inlinestart: "three" }}>
          <UitkCardAlohaPlaceholder className="placeholder-header" />
        </UitkSpacing>
        <UitkSpacing margin={{ inlinestart: "three", blockstart: "two" }}>
          <UitkCardAlohaPlaceholder className="placeholder-subheader" />
        </UitkSpacing>
        <UitkSpacing margin={{ blockstart: "three" }}>
          <IsomorphicCarousel
            className="carouselComponent"
            itemsVisible={{
              lg: 3,
              md: 2,
              sm: 1,
            }}
            buttonText={{
              nextButton: formatText("carousel.item.next"),
              prevButton: formatText("carousel.item.prev"),
            }}
            pageBy={1}
            peekWidth={24.8}
          >
            {[...Array(4)].map((val, index) => (
              <div key={keyHelper.next()} className="uitk-carousel-item uitk-cell">
                <UitkCardAlohaPlaceholder className="placeholder-card" />
              </div>
            ))}
          </IsomorphicCarousel>
        </UitkSpacing>
      </div>
    </UitkSpacing>
  );
};
